import { render, staticRenderFns } from "./MatzoCoupons.vue?vue&type=template&id=4c3e040b&"
import script from "./MatzoCoupons.vue?vue&type=script&lang=js&"
export * from "./MatzoCoupons.vue?vue&type=script&lang=js&"
import style0 from "./MatzoCoupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports